import type { OfferDetail } from './types';

type Entry = OfferDetail['fixedFields'][number]['entries'][number];
// Scalar database columns are for sorting/filtering. The visible header uses
// the same literal claims as details, including ranges and conflicting values.
export function metricValues(entries: Entry[] | undefined, fallback: string) {
  return entries?.length ? entries.map(entry => ({ value: entry.value, sourceNumbers: entry.sourceNumbers, citations: entry.citations || [] }))
    : [{ value: fallback, sourceNumbers: [] as number[], citations: [] }];
}
